import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { API } from '../App';
import { ArrowRight } from 'lucide-react';

const Blog = () => {
  const [blogs, setBlogs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchBlogs = async () => {
      try {
        const response = await axios.get(`${API}/blog`);
        setBlogs(response.data);
      } catch (error) {
        console.error('Error fetching blogs:', error);
      } finally {
        setLoading(false);
      }
    };
    fetchBlogs();
  }, []);

  return (
    <div className="pt-16 min-h-screen bg-[#050505]" data-testid="blog-page">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        {/* Header */}
        <div className="mb-12">
          <span className="text-sm uppercase tracking-[0.2em] font-semibold text-zinc-500">Insights</span>
          <h1 className="font-outfit text-4xl md:text-5xl font-black text-white mt-2">
            Our <span className="text-red-500">Blog</span>
          </h1>
          <p className="text-zinc-400 mt-4 max-w-2xl">
            Educational insights, study tips, and updates from STUDY POINT.
          </p>
        </div>

        {/* Blog Grid */}
        {loading ? (
          <div className="flex justify-center py-20">
            <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-red-500"></div>
          </div>
        ) : blogs.length === 0 ? (
          <div className="text-center py-20">
            <p className="text-zinc-500 text-lg">No blog posts yet.</p>
            <p className="text-zinc-600 mt-2">Check back soon for educational content!</p>
          </div>
        ) : (
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {blogs.map((blog, idx) => (
              <Link
                key={blog.blog_id}
                to={`/blog/${blog.blog_id}`}
                className={`card-hover bg-[#121212] rounded-sm overflow-hidden group animate-fadeIn stagger-${(idx % 5) + 1}`}
                data-testid={`blog-${blog.blog_id}`}
              >
                {blog.image_url ? (
                  <div className="h-48 overflow-hidden">
                    <img
                      src={blog.image_url}
                      alt={blog.title}
                      className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-110"
                    />
                  </div>
                ) : (
                  <div className="h-48 bg-gradient-to-br from-red-600/20 to-zinc-800 flex items-center justify-center">
                    <span className="font-outfit text-6xl font-black text-red-500/20">SP</span>
                  </div>
                )}
                <div className="p-6">
                  <div className="flex items-center gap-2 text-sm text-zinc-500 mb-3">
                    <span>{blog.author}</span>
                    <span>•</span>
                    <span>{new Date(blog.created_at).toLocaleDateString()}</span>
                  </div>
                  <h3 className="font-outfit text-xl font-bold text-white mb-3 group-hover:text-red-500 transition-colors line-clamp-2">
                    {blog.title}
                  </h3>
                  <p className="text-zinc-400 line-clamp-3 mb-4">{blog.content}</p>
                  <span className="inline-flex items-center gap-1 text-red-500 text-sm font-semibold">
                    Read More <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
                  </span>
                </div>
              </Link>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default Blog;
